import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'search',
})
export class SearchPipe implements PipeTransform {
	transform(value: any[], arg: any, type: string = 'name', type2: string = ''): any {
		if (value !== undefined) {
			let result = [];
			for (const element of value) {
				if (element[type].toLowerCase().indexOf(arg.toLowerCase()) > -1) {
					result.push(element);
				}
				if (type2 !== '') {
					if (element[type2].toLowerCase().indexOf(arg.toLowerCase()) > -1) {
						result.push(element);
					}
				}
			}
			let data: any[] = [];
			result.forEach((item) => {
				if (!data.find((itemResult) => itemResult[type] === item[type])) {
					data.push(item);
				}
			});
			return data;
		}
	}
}
